var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMainImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 889,
    height: 739.5,
    viewBox: "0 0 889 739.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,17,16)",
    fillRule: "evenodd",
    d: "M136.63066373 182.60487067c46.68607369-46.5952424 111.20735758-68.9134418 181.10298514-76.44121292 198.4075352-21.36852573 333.24825424-86.02968945 464.67063146 86.72687494 131.42237723 172.75656439 166.6305742 558.66098673-41.48026945 473.95964749-208.11084364-84.70133924-419.17919405 142.30254651-604.29334715 50.25840295-185.1141531-92.04414356-179.21036933-355.64201054 0-534.50371246z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 277.167,
    height: 158.588,
    x: 192.464,
    y: 114.193,
    fill: "rgb(24,32,28)",
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("rect", {
    width: 156.351,
    height: 113.616,
    x: 213.785,
    y: 140.23,
    fill: "rgb(41,55,48)",
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("rect", {
    width: 68.7,
    height: 63.909,
    x: 190.095,
    y: 28.981,
    fill: "rgb(5,141,159)",
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("rect", {
    width: 191.885,
    height: 63.909,
    x: 277.746,
    y: 28.981,
    fill: "rgb(26,24,24)",
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "rgb(208,208,208)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    d: "M289.17859738 77.84219538c7.79364687-4.36943447 21.43805995-11.6401776 40.06796844-8.74207918 27.835804 4.3227439 46.82802587-22.9227041 59.1837331-18.17979062 15.50686795 5.95253124 18.61912066 17.37179012 25.0185877 19.82831632 12.84750688 4.93169776 30.9290938-1.83003731 44.74970304-16.76443345"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 49.748,
    height: 4.734,
    x: 199.571,
    y: 40.816,
    fill: "rgb(222,222,222)",
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("rect", {
    width: 49.748,
    height: 4.734,
    x: 199.571,
    y: 55.018,
    fill: "rgb(222,222,222)",
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("rect", {
    width: 49.748,
    height: 4.734,
    x: 199.571,
    y: 71.587,
    fill: "rgb(222,222,222)",
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("rect", {
    width: 66.331,
    height: 4.734,
    x: 225.629,
    y: 156.799,
    fill: "rgb(5,141,159)",
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("rect", {
    width: 66.331,
    height: 4.734,
    x: 225.629,
    y: 171,
    fill: "rgb(5,141,159)",
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("rect", {
    width: 66.331,
    height: 4.734,
    x: 225.629,
    y: 185.202,
    fill: "rgb(5,141,159)",
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("rect", {
    width: 66.331,
    height: 4.734,
    x: 225.629,
    y: 199.404,
    fill: "rgb(5,141,159)",
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("rect", {
    width: 66.331,
    height: 4.734,
    x: 225.629,
    y: 215.973,
    fill: "rgb(5,141,159)",
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("rect", {
    width: 66.331,
    height: 4.734,
    x: 225.629,
    y: 230.175,
    fill: "rgb(5,141,159)",
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("rect", {
    width: 111.341,
    height: 68.643,
    x: 318.018,
    y: 128.395,
    fill: "rgb(26,24,24)",
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 372.504,
    cy: 140.23,
    fill: "rgb(5,141,159)",
    rx: 4.738,
    ry: 4.734
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 372.504,
    cy: 187.569,
    fill: "rgb(5,141,159)",
    rx: 4.738,
    ry: 4.734
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "rgb(5,141,159)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    d: "M372.50411885 140.22955674v47.33983842"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "rgb(253,131,105)",
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeWidth: 2,
    d: "M422.25205945 301.18501491l56.85477892 2.3669917"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,131,105)",
    fillRule: "evenodd",
    d: "M209.04663848 520.1590208l83.88415929 46.12906513 139.42315187-36.61128275 1.74285542-94.45574907-94.91168084-41.72336268-130.13848574 33.66542707v92.9959023z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(245,213,206)",
    fillRule: "evenodd",
    d: "M430.86957845 436.84895108l-134.72776127 34.12318946-87.0951787-43.80902204 123.18535433-33.66542707 98.63758564 43.35125965z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,159,138)",
    fillRule: "evenodd",
    d: "M292.93079777 566.28808593l3.21101941-95.3159454 137.95498788-35.75108642-1.17852526 94.7145964-139.98748203 36.35243542z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,88,127)",
    fillRule: "evenodd",
    d: "M364.58933417 391.34623887c2.63087016-2.99284697 72.7540835 25.93800709 82.74612838 39.84161898 9.99204488 13.9036119-59.45240395 118.91053573-87.71321125 139.83421149-3.1570442-2.15800019-10.80761463-7.62913447-10.80761463-7.62913447s23.7725428-72.82594298 45.38251032-97.37778936c-5.48273342-1.49117288-23.27267747-6.1379616-23.27267747-6.1379616l-19.50527139-60.90706118c3.09916505-1.28639913 9.71843438-3.70167915 13.17013604-7.62388386z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(5,110,159)",
    fillRule: "evenodd",
    d: "M351.62679262 398.23167484L448.3104998 593.664842l-14.00744257 5.7611278s-71.3154384-88.56948385-73.6120013-95.17383126c-4.1847301-2.48252235-72.8376406-56.07672306-80.57594379-94.67104193 10.98425353 1.91164695 53.11265805-2.00591996 71.5116805-11.34942177z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,104)",
    fillRule: "evenodd",
    d: "M386.84061232 286.98306468c5.74002284 4.05075066 12.04122109 12.26244078 15.31207209 40.58096576 5.79881263-2.62354317 39.39985877-18.39628471 39.39985877-18.39628471s8.1771275 4.5282355 6.541702 6.71627051c-1.6354255 2.188035-40.8856375 41.89273734-52.48326277 44.37460918-9.08569722 2.04636368-31.96562064-27.58917997-32.55886322-30.80039681-.59324258-3.21121684 10.10650203-37.9521755 10.10650203-37.9521755l13.6819911-4.52298843z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 449.408,
    cy: 305.026,
    fill: "rgb(222,142,104)",
    rx: 14.021,
    ry: 11.634,
    transform: "rotate(-64.910023 449.40834468 305.02574457)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,196,134)",
    fillRule: "evenodd",
    d: "M341.4281515 251.668586c17.54092296-12.60021686 55.67382636 25.08859749 54.74894134 32.13428088-.92488503 7.0456834-22.5055357 34.93551253-36.77215303 28.16675697-14.26661733-6.76875555-30.4467899-51.35946383-17.9767883-60.30103785z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,211,133)",
    fillRule: "evenodd",
    d: "M322.15048717 234.90924716c-70.47500763 0-54.49618728 162.373161-46.42793425 171.5656877 18.84870058 10.51177565 79.42104454-4.2796436 87.62595854-15.75710948 6.5281891-9.40888353 22.92750472-155.80857822-41.1980243-155.80857822z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,104)",
    fillRule: "evenodd",
    d: "M249.95879406 291.7170481c-4.12517633 5.57960052-23.74374745 55.74341718-18.7977996 70.09997652 8.71936494 25.24230212 68.9714558 71.9195258 68.9714558 71.9195258 1.06593704-4.20705035 3.6721531-16.30232012 3.6721531-16.30232012s-41.14516954-56.44809813-43.28770298-60.67618373c3.36303135-5.13260144 18.046314-33.50389726 19.42670246-48.29693807 1.38038846-14.7930408-29.98480878-16.7440604-29.98480878-16.7440604z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,124,89)",
    fillRule: "evenodd",
    d: "M332.23199281 247.5956957c0 5.33230272-23.68949121 5.01863785-23.68949121 0V213.6063218h23.68949121v33.98937388z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 330.032,
    cy: 201.211,
    fill: "rgb(222,142,104)",
    rx: 21.394,
    ry: 31.588,
    transform: "rotate(-1.08 330.031573 201.21092288)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 307.358,
    cy: 207.689,
    fill: "rgb(222,142,104)",
    rx: 5.922,
    ry: 5.917
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillRule: "evenodd",
    d: "M336.39807575 154.2372905c-16.01082854-2.17275303-33.80964186 12.69776929-37.25491077 18.20190694-4.33403326 6.90673644-7.18330724 13.98348485-7.18330724 18.98821233 0 9.18064658 5.55739127 13.21843096 10.06394938 14.9185507 1.008876-2.23176465 3.21805254-3.64886992 5.63458583-3.61437902 2.4165333.0344909 4.58567555 1.51408743 5.53247695 3.77376524 3.16818354-1.39197303 3.4243568-3.84120803 3.4243568-4.6487649 0-2.92739368-3.10021921-7.96931128 1.27563826-12.53838307 3.6909861-3.86245953 24.28940716-2.60862123 27.94902511-7.0608098 1.39065483 2.12514968 2.75516952 6.54014813 3.1368154 7.74617057 1.03143137.22457988 2.08208775.3455868 3.13681538.36127544 9.22746527 0 12.54726156-4.78158676 12.54726156-7.96931127 0-4.78158677-4.18242052-6.55077387-4.18242052-9.56317353-.03136815-5.33412568-8.06945759-16.42230661-24.08028614-18.59505964z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,104)",
    fillRule: "evenodd",
    d: "M358.29043316 232.23700436l2.36894912.6105022"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,216,146)",
    fillRule: "evenodd",
    d: "M291.95985774 249.1111974c18.96767845 8.71411436-2.1049448 60.78560047-8.4952088 63.2918259-6.39026399 2.50622543-40.19564587-2.49049599-41.22683762-17.42822874-1.03119174-14.93773275 36.27488943-52.0505135 49.72204642-45.86359717z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillRule: "evenodd",
    d: "M431.72785593 600.2092144l13.28314247-5.517228h27.5897138l1.76822793 4.5136129-37.07384538 14.42232074-5.56723882-13.41870564z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillRule: "evenodd",
    d: "M347.82886481 563.92109422l11.13251254 8.4357607 13.54275054 23.29300754-2.90570448 3.77610735-30.25958323-24.0292959 8.49002463-11.47557969z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(51,102,106)",
    fillRule: "evenodd",
    d: "M739.47004425 316.51016483c2.67475191 8.56272403-19.76641659 10.33486289-21.0395985 6.23646506-1.2731819-4.09839783 18.19366248-15.3951296 21.0395985-6.23646506z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(51,102,106)",
    fillRule: "evenodd",
    d: "M736.82037447 337.05163776c3.92678527 8.25373193-16.41837007 14.16863515-18.29661557 10.21813098-1.87824551-3.95050417 14.06931101-19.0525002 18.29661557-10.21813098z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(51,102,106)",
    fillRule: "evenodd",
    d: "M736.8202835 365.45553823c3.92667277 8.25373192-16.41289119 14.16863515-18.2960914 10.21813098-1.8832002-3.95050417 14.10396753-19.0525002 18.2960914-10.21813098z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(51,102,106)",
    fillRule: "evenodd",
    d: "M739.21567719 388.77483461c3.5875912 7.04535808-14.24469945 11.71679218-15.96050394 8.32911096-1.71580449-3.38768121 12.1213285-15.86351776 15.96050394-8.32911096z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(51,102,106)",
    fillRule: "evenodd",
    d: "M741.58462768 414.8133938c3.58758088 7.04412851-14.24465846 11.71474734-15.96045801 8.32765735-1.71579955-3.38709 12.11626194-15.86584259 15.96045801-8.32765735z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "rgb(51,102,106)",
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeWidth: 3,
    d: "M682.83646286 518.94825182c.62591715-2.9627831 30.92341123-25.03842181 38.09818062-59.19228679 11.69068407-55.66969085-12.90113543-90.21964982-4.55212477-129.98748704 1.55186072-7.51522342 7.24201668-31.04848805 20.93977395-38.0514299"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(51,102,106)",
    fillRule: "evenodd",
    d: "M708.65077098 450.8812837c6.63070667-3.97913337 11.95298012 13.90139392 8.7753566 15.80912752-3.17762352 1.9077336-15.87336085-11.54869297-8.7753566-15.80912753z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(51,102,106)",
    fillRule: "evenodd",
    d: "M707.78722156 428.02290385c5.76199496-6.02644452 17.67123454 9.35780098 14.91307029 12.24428685-2.75816426 2.88648588-21.08264823-5.79883632-14.9130703-12.24428685z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(51,102,106)",
    fillRule: "evenodd",
    d: "M710.15617068 404.35296265c5.76199496-6.02633965 17.67123454 9.35763815 14.91307029 12.2440738-2.75816426 2.88643564-21.08264823-5.7935626-14.91307029-12.2440738z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(51,102,106)",
    fillRule: "evenodd",
    d: "M704.83315055 383.55923695c4.09927122-6.5827019 17.66785895 5.8343319 15.71558103 8.98536348-1.95227791 3.15103158-20.08130488-1.93985381-15.71558103-8.98536348z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(51,102,106)",
    fillRule: "evenodd",
    d: "M700.58194293 354.75301663c5.5051481-6.27818825 17.68804087 9.06966457 15.05107492 12.07708528-2.63696594 3.00742071-20.94708855-5.35647437-15.05107492-12.07708528z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(51,102,106)",
    fillRule: "evenodd",
    d: "M700.72254961 323.64182962c5.4587727-5.44219513 15.09102527 9.98978285 12.46585185 12.59905449-2.62517342 2.60927164-18.33651376-6.75428601-12.46585185-12.59905449z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(51,102,106)",
    fillRule: "evenodd",
    d: "M719.67864005 283.4103923c5.45687106-5.46424185 15.0857681 9.98466008 12.4615092 12.59259369-2.6242589 2.6079336-18.34500837-6.7706924-12.4615092-12.5925937z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(51,102,106)",
    fillRule: "evenodd",
    d: "M681.98573349 427.12639614c-1.55956915-4.11619794-2.65232849-15.3569885-2.65232849-20.82250133 0-36.70451506-22.01963107-43.57709555-33.28141781-43.57709555-21.9188426 0-34.283998 20.06121471-34.283998 36.51550597 0 14.55369987 6.2382766 27.49032197 13.88759195 38.42134763 3.03972537-3.67846613 8.02649829-5.17013518 12.61587034-3.77372373 4.58937205 1.39641145 7.86830645 5.40309306 8.2952667 10.13637006.42696025 4.733277-2.08299566 9.2514833-6.34985366 11.43045931 6.31784645 6.9723353 11.54293356 12.3853456 12.84257452 16.0080198 4.41877925 12.10708222 2.50379809 17.85085843 5.00229152 23.77314322 6.0897462 14.43294406 12.2908902 21.94605535 19.7121053 21.30552455 17.2083072-1.48582145 24.0141821-15.92926601 24.0141821-53.25331087.02652328-10.57400849-13.8822873-20.5599887-19.80228447-36.16373906z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.761
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,211)",
    fillRule: "evenodd",
    d: "M533.59266818 389.12738835l-99.49586312 23.30623672v-226.9664857l99.49586312-26.30162679v229.96187577z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(149,75,59)",
    fillRule: "evenodd",
    d: "M710.98651515 585.22401704H663.9354946c-2.19619379.00129409-4.14576694-1.39471024-4.83652354-3.46322364l-23.38451153-70.38368534c-.51245995-1.53848271-.24930194-3.22754559.7074423-4.54067315.95674422-1.31312756 2.49072181-2.09062599 4.12376054-2.09013309h94.05415475c1.63604705.00016905 3.17236525.78033503 4.12937005 2.09695754.9570048 1.3166225 1.21811933 3.00931807.70183279 4.54968661L715.81771799 581.771352c-.69243289 2.06351664-2.6392606 3.45483557-4.83120284 3.45266504z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainImg);
export default __webpack_public_path__ + "static/media/main-img.6d2853844fc033befbd12a179a63d01e.svg";
export { ForwardRef as ReactComponent };